exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.appbarvertical[data-v-aa0c0268] {\n    width:250px\n}\n.item-color[data-v-aa0c0268]{\n    background-color: #FFA500;\n    /*>a{\n        background-color: #FFA500;    \n    }*/\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa0c0268","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/TheSidebar.vue
// module id = 532
// module chunks = 79